<template>
  <div class="" style="height:900px !important;">

    <search-nav class="mt-4" @handleSearch="handleSearch">
      <search-nav-item-date :label="$t('search.대상기간')" v-model="nav.date" />
      <search-nav-item-project :label="$t('search.사무소명')" v-model="nav.projectId" />
    </search-nav>

    <vs-row class="mb-4">
      <vs-col class="flex" vs-justify="flex-end">
        <vs-button class="mr-2" type="border" color="secondary" @click="excelDownFunc">{{$t('button.Excel 다운로드')}}</vs-button>
        <vs-button class="mr-2" type="border" color="secondary" @click="handleClickApprovalLine">{{$t('button.결재선 지정')}}</vs-button>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col>
        <vs-table stripe
                  ref="table"
                  :sst="true"
                  :max-items="table.perPage"
                  :data="table.list"

                  @sort="handleSort"
                  @selected="handleItemClickDetailBlank"
        >

          <template slot="thead">
            <vs-th sort-key="id"><span class="w-full text-center">{{$t('content.risk.conference.warning.column.No')}}</span></vs-th>
            <vs-th sort-key="content$preview.title"><span class="w-full text-center">{{$t('content.risk.conference.warning.column.사무소명')}}</span></vs-th>
            <vs-th sort-key="content$preview.meetingPlace"><span class="w-full text-center">{{$t('content.risk.conference.warning.column.회의장소')}}</span></vs-th>
            <vs-th sort-key="content$preview.meetingDate"><span class="w-full text-center">{{$t('content.risk.conference.warning.column.회의일')}}</span></vs-th>
            <vs-th sort-key="created_at"><span class="w-full text-center">{{$t('content.risk.conference.warning.column.대상기간')}}</span></vs-th>
            <vs-th sort-key="content$preview.writer"><span class="w-full text-center">{{$t('content.risk.conference.warning.column.작성자')}}</span></vs-th>
            <vs-th sort-key="status"><span class="w-full text-center">{{$t('content.risk.conference.warning.column.결재상태')}}</span></vs-th>
            <vs-th style="width: 200px !important; display: inline-block;"><vs-col vs-type="flex" vs-justify="center">{{$t('content.risk.conference.warning.column.보기')}}</vs-col></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td class="text-center">{{ getNo(indextr) }}</vs-td>
              <vs-td class="text-center">{{ getPreview(tr).title }}</vs-td>
              <vs-td class="text-center">{{ getPreview(tr).meetingPlace }}</vs-td>
              <vs-td class="text-center">{{ getPreview(tr).meetingDate }}</vs-td>
              <vs-td class="text-center">{{ getContent(tr).created_at.substr(0, 10) }}</vs-td>
              <vs-td class="text-center">{{ getPreview(tr).writer }}</vs-td>
              <vs-td class="text-center">{{ tr.document_status.name }}</vs-td>
              <vs-td class="text-center">
                <div class="flex justify-center">
                  <vs-button type="border" icon="open_in_new" class="mr-1" @click="()=>{handleItemClickDetailBlank(tr)}"></vs-button>
                  <vs-button type="border" @click.stop="()=>{handleItemClickDetail(tr)}">{{$t('button.바로가기')}}</vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination
              :total="(lastPage) ? lastPage : 1"
              v-model="currentPage" @change="handleChangePage"></k-pagination>
          </div>
        </div>
      </vs-col>
    </vs-row>

    <popup-approval-process
      v-model="approvalLine"
      :show-popup="showApprovalLinePopup"
      @closePopup="handleCloseApprovalPopup" />

    <popup-excel-download
      v-model="showExcelDownload"
      :list="excelList"
      title="위험성평가협의회"/>

  </div>
</template>

<script>
import PopupApprovalProcess from '@/views/content/approval/PopupApprovalProcess'
import PopupExcelDownload from '@/views/components/popup/PopupExcelDownload'
import SearchNav from '@/views/components/nav/SearchNav'
import SearchNavItemDate from '@/views/components/nav/SearchNavItemDate'
import SearchNavItemKeyword from '@/views/components/nav/SearchNavItemKeyword'
import KPagination from '@/views/components/kPagination/kPagination'
import SearchNavItemProject from '@/views/components/nav/SearchNavItemProject'

export default {
  name: 'RiskConferenceWarning',
  components: {
    SearchNavItemProject,
    KPagination,
    SearchNavItemKeyword, SearchNavItemDate, SearchNav, PopupExcelDownload, PopupApprovalProcess},
  data () {
    return {
      // 검색 네비게이션
      nav: {
        date: ['', ''],
        orderNum:'',
        projectId:'',
        dateTarget:'created_at',
        orderTarget:'created_at',
        orderDirection:'desc'
      },

      // approvalLine
      approvalLine: [],
      showApprovalLinePopup: false,
      showExcelDownload: false,

      rootPath: '', // 프로젝트의 rootPath
      lastPage: 1,
      currentPage: 1,
      total: 0,
      table: {
        list: [],
        perPage: 10,
        keyword: ''
      },
      listAll: []
    }
  },
  computed: {
    excelList () {
      const list = []
      for (const data of this.listAll) {
        list.push({
          사무소명: this.getPreview(data).title,
          회의구분: this.getPreview(data).meetingType,
          회의일: this.getPreview(data).meetingDate,
          회의장소: this.getPreview(data).meetingPlace,
          대상기간: data.created_at,
          결재상태: data.document_status.name
        })
      }

      return list
    }
  },
  created () {
    const paths = this.$route.path.split('/')
    this.rootPath = `/${paths[1]}/${paths[2]}`
    this.loadPostList()
  },
  methods: {
    getNo (index) {
      return this.total - (((this.currentPage - 1) * this.table.perPage) + index)
    },

    async loadPostList () {
      const projectId = this.nav.projectId
      const boardSlug = 'risk_evaluation_association' // first_risk(id:6)
      const page = this.currentPage
      const perPage = this.table.perPage
      const keyword = []
      const dateTarget = []
      const dateBegin = []
      const dateEnd = []
      const orderTarget = this.nav.orderTarget
      const orderDirection = this.nav.orderDirection

      if (this.nav.keyword) keyword.push(this.nav.keyword)
      if (this.nav.company) keyword.push(`content$preview.company*%${this.nav.company}%`)
      if (this.nav.orderNum) keyword.push(`contentd$orderNumber*${this.nav.orderNum}`)

      if (this.nav.dateTarget) dateTarget.push(this.nav.dateTarget)
      if (this.nav.date[0]) dateBegin.push(this.nav.date[0])
      if (this.nav.date[1]) dateEnd.push(this.nav.date[1])

      await this.$store.dispatch('approval/LOAD_POST_ALL', {
        projectId,
        boardSlug,
        page,
        perPage,
        dateTarget, dateBegin, dateEnd,
        orderTarget, orderDirection,
        keyword
      })

      this.table.list = this.$store.state.approval.list
      const listInfo = this.$store.state.approval.postListInfo
      this.currentPage = listInfo.current_page
      this.lastPage = listInfo.last_page
      this.total = listInfo.total
    },

    async loadPostListAll () {
      const projectId = this.nav.projectId
      const boardSlug = 'risk_evaluation_association'
      const page = 1
      const perPage = 10000
      const keyword = []
      const dateTarget = []
      const dateBegin = []
      const dateEnd = []
      const orderTarget = this.nav.orderTarget
      const orderDirection = this.nav.orderDirection
      if (this.nav.keyword) keyword.push(this.nav.keyword)
      if (this.nav.company) keyword.push(`content$preview.company*%${this.nav.company}%`)
      if (this.nav.orderNum) keyword.push(`contentd$preview.orderNumber*${this.nav.orderNum}`)

      if (this.nav.dateTarget) dateTarget.push(this.nav.dateTarget)
      if (this.nav.date[0]) dateBegin.push(this.nav.date[0])
      if (this.nav.date[1]) dateEnd.push(this.nav.date[1])

      await this.$store.dispatch('approval/LOAD_POST_ALL', {
        projectId,
        boardSlug,
        page,
        perPage,
        dateTarget, dateBegin, dateEnd,
        orderTarget, orderDirection,
        keyword
      })
      this.listAll = JSON.parse(JSON.stringify(this.$store.state.approval.list))
      await this.loadPostList()
    },

    getPreview (data) {
      if (data.post.preview) {
        const preview = JSON.parse(data.post.preview)
        return preview
      }
    },

    getContent (data) {
      if (data.post) {
        const content = data.post
        return content
      }
    },

    getOrderNumber (data) {
      if (data.post && data.post.post_content) {
        const content = JSON.parse(data.post.post_content)
        return content.orderNumber
      }
    },

    handleItemClickDetail (data) {
      if (data.post) {
        this.$router.push(`/project/${data.post.project_id}/risk/conference/warning/${data.post.id}`)
      }
    },
    handleItemClickDetailBlank (data) {
      if (data.post) {
        const routeData = this.$router.resolve(`/project/${data.post.project_id}/risk/conference/warning/${data.post.id}`)
        window.open(routeData.href, '_blank')
      }
    },

    handleSearch () {
      this.currentPage = 1
      this.loadPostList()
    },

    async excelDownFunc () {
      await this.loadPostListAll()
      this.showExcelDownload = true
    },
    handleClickApprovalLine () {
      this.showApprovalLinePopup = true
    },
    handleCloseApprovalPopup () {
      this.showApprovalLinePopup = false
    },

    handleChangePage (page) {
      this.currentPage = page
      this.loadPostList()
    },

    handleSort (key, type) {
      if (key) {
        this.nav.orderTarget = key
        this.nav.orderDirection = type
        this.loadPostList()
      }
    },
  }
}
</script>

<style scoped>

</style>
